import { EMPTY_BILLING_TYPE_MAPPING_MODEL } from "presentation/model/BillingTypeMapping/BillingTypeMappingModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: BillingTypeMappingProvider,
    useTracked: useBillingTypeMappingTracked
} = createContainer(() => useState(EMPTY_BILLING_TYPE_MAPPING_MODEL), {concurrentMode: true});
export { BillingTypeMappingProvider, useBillingTypeMappingTracked };
